import { IUser } from '@sdk/contracts';

type SocketHandler<T extends unknown[] = unknown[]> = (...args: T) => void;

export interface ISocketActions {
  connect: (user: IUser) => (() => void) | undefined;
  on: <T extends unknown[] = unknown[]>(event: string, handler: SocketHandler<T>) => void;
  off: <T extends unknown[] = unknown[]>(event: string, handler?: SocketHandler<T>) => void;
  once: <T extends unknown[] = unknown[]>(event: string, handler: SocketHandler<T>) => void;
  emit: (event: string, ...args: unknown[]) => void;
  emitSafe: (event: string, payload: unknown) => void;
  hasListeners: (event: string) => boolean;
}

let socketActions: ISocketActions | null = null;
let isInitialized = false;

export const initSocketActions = (actions: ISocketActions) => {
  if (isInitialized) {
    return;
  }
  socketActions = actions;
  isInitialized = true;
};

export const useSocket = (): ISocketActions => {
  if (!socketActions) {
    throw new Error('useSocket must be used within SocketProvider');
  }
  return socketActions;
};
